import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { lightTheme } from './Themes';
import { Design, Develope } from './AllSvgs';


import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';
import ParticleComponent from '../subComponents/ParticleComponent';
import BigTitle from '../subComponents/BigTitlte'

const Box = styled.div`
background-color: ${props => props.theme.body};
width: 100vw;
height:100vh;
position: relative;
display: flex;
justify-content: space-evenly;
align-items: center;

@media (max-width: 768px) {
    flex-direction: column;
    padding: 1rem;
    justify-content: space-evenly;
    
  }


`

const Main = styled.div`
border: 2px solid ${props => props.theme.text};
color: ${props => props.theme.text};
background-color: rgba(0, 0, 0, 0.01);
padding: 2rem;
width: 30vw;
height: 60vh;
z-index:3;
line-height: 1.5;
cursor: pointer;

font-family: 'Ubuntu Mono',monospace;
display: flex;
flex-direction: column;
justify-content: space-between;

&:hover{
    color: ${props => props.theme.body};
    background-color: rgba(0, 0, 0, 0.7);
}

@media (max-width: 768px) {
    flex-direction: column;
    width: 55vw;
    height: auto;
    
    margin-top:5rem;

    
  }

`

const Title = styled.h2`
display: flex;
justify-content: center;
align-items: center;
font-size: calc(1em + 1vw);

${Main}:hover &{
    &>*{
        fill:${props => props.theme.body};
    }
}

&>*:first-child{
margin-right: 1rem;
}
@media (max-width: 768px) {
     
    font-size: calc(1em + 0.5vw);
    
  }
`

const Description = styled.div`
color: ${props => props.theme.text};
font-size: calc(0.5em + 1vw);
padding: 0.5rem 0;


${Main}:hover &{
   
        color:${props => props.theme.body};
    
}

strong{
    margin-bottom: 1rem;
    text-transform: uppercase;
}
ul,p{
    margin-left: 2rem;
}

@media (max-width: 768px) {
     
    font-size: calc(0.5em + 1.5vw);
    
  }
`

const MySkillsPage = () => {
    return (
        <ThemeProvider theme={lightTheme}>
            <Box>

                <LogoComponent theme='light' />
                <SocialIcons theme='light' />
                <PowerButton />
                <ParticleComponent theme='light' />
                <Main>
                    <Title>
                        <Design width={40} height={40} /> Designer
                    </Title>
                    <Description>
                        I love to create design which speaks, Keep it clean, minimal and simple.
                    </Description>
                    <Description>
                        <strong>I like to Design</strong>
                        <p>
                            Web Design, Mobile Apps
                        </p>
                    </Description>
                    <Description>
                        <strong>Tools</strong>

                        <ul>
                            <li>
                                Figma
                            </li>
                            <li>
                                Adobe PS
                            </li>
                            <li>
                                Framer
                            </li>
                            <li>
                                Spline
                            </li>

                        </ul>

                    </Description>

                </Main>
                <Main>
                    <Title>
                        <Develope width={40} height={40} /> Full-Stack Developer
                    </Title>
                    <Description>
                        I love bringing new concepts to life. As a full-stack developer, I enjoy shaping both the user experience and the backend.
                    </Description>
                    <Description>
                        <strong>Skills</strong>
                        <p>
                            HTML, CSS, JavaScript, TypeScript, React, Next.js, Redux, Tailwind, ShadCN, Node.js, Express, MongoDB
                        </p>
                    </Description>
                    <Description>
                        <strong>Tools</strong>
                        <p>
                            VScode, Github
                        </p>
                    </Description>

                </Main>

                <BigTitle text="SKILLS" top="80%" right="30%" />

            </Box>

        </ThemeProvider>

    )
}

export default MySkillsPage
